import React, { Fragment } from "react";
import i18next from "i18next";
import { withTranslation, Trans } from "react-i18next";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import Card from '@material-ui/core/Card';
import LockOpenIcon from "@material-ui/icons/LockOpen";
import CardContent from '@material-ui/core/CardContent';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import classnames from "classnames";
import Services from "../../api/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setLangID } from "../../redux/actions/appActions";
import DependentQuestionnaire from "./DependentQuestionnaire";
import RadioElements from "./radioElements";
// import Attachmentpopup from "./attachmentpopup.js";
import EvidenceCapture from "./EvidenceCapture";


const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

let dependantquestionArr = [];

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
      adminObj: JSON.parse(localStorage.getItem('adminobj')) != null ? JSON.parse(localStorage.getItem('adminobj')) : {}
    };
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this)
    this.handleChangeRadio = this.handleChangeRadio.bind(this)

  }

  componentDidMount() { }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  callsameCompomnet = () => {
    const { classes } = this.props;
    if (this.state.dependantquestionlist.length > 0) {
      return this.state.dependantquestionlist.map((Obj, index) => {
        return (
          <Questionnaire
            key={index}
            question={Obj}
            classes={classes}
            componentbgcolor={this.props.componentbgcolor}
          />
        );
      });
    }
    //return null;
  };

  updateUrl(url, type) {
    this.props.updateUrl(url, type)
  }


  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    var quslist = [];
    return (
      <>
        {
          templateID == 1 ? (
            <Card className="infocard">
              <CardContent className="pt-0px pb-0px">
                <Grid container spacing={3} className="gridcontainer border-bottom-grey">
                  <Grid item xs={2} className="text-center hospitaliconholder color-purple">
                    <LocalHospitalIcon />
                  </Grid>
                  <Grid item xs={10} className="text-left">
                    <p className="hospitalinfo">
                      {element.question}
                      {element.isMandatory && <sup className="text-red">*</sup>}
                      </p>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer">

                  <Grid item xs={12} className="text-left reportdetailedtextholder">
                    <div className="reportform">
                      <FormControl component="fieldset" className={classes.formControl}>
                        <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      </FormControl>
                      {
                        this.callsameCompomnet()
                      }
                    </div>
                  </Grid>
                </Grid>
                {/* <Grid container spacing={3} className="gridcontainer border-top-grey">
                  <Grid item xs={12} className="text-left color-purple">
                  <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>
                  </Grid>
                </Grid> */}
              </CardContent>
            </Card>
          ) : (
            <>
              <Grid
                key={element.id}
                container
                spacing={0}
                className="gridcontainer chatuserlistdiv"
              >
                <Grid item xs={2} className="zero">
                  <p className="zero  text-center forumicon">
                    <LockOpenIcon style={bgStyles} />
                  </p>
                </Grid>
                <Grid item xs={10} className="zero">
                  <p className="zero  chatusername" style={colorStyles}>
                    {element.question}
                    {element.isMandatory && <sup className="text-red">*</sup>}
                 </p>
                </Grid>
              </Grid>
              <div className={classes.root}>
                <div className="reportform">
                  <FormControl component="fieldset" className={classes.formControl}>
                    <FormGroup>{this.getQuestionType(element)}</FormGroup>
                    {
                      this.callsameCompomnet()
                    }
                  </FormControl>
                </div>
              </div>
            </>
          )
        }
      </>
    );
  }

  getQuestionType(element) {
    var type = element.type ? element.type.toLowerCase() : ''
    switch (type) {
      case "text":
        return this.getTextType(element);
      case "number":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
      case "dropdown":
        return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
      default:
        return this.getTextType(element);
    }
  }

  handleChangeRadio(values) {
    if (this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
      var dependList = this.props.question.dependentQuestionsList.filter(o => o.selectedOption.includes(values))
      this.setState({ dependantquestionlist: dependList })
    }
  }


  handleChangeCheckbox(event) {
    var values = event.target.value
    if (event.target.checked) {
      dependantquestionArr.push(values)
    } else {
      dependantquestionArr = dependantquestionArr.filter(c => c !== values)
    }
    if (this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
      var dependList = this.props.question.dependentQuestionsList.filter(o => o.selectedOption.some(r => dependantquestionArr.includes(r)))
      this.setState({ dependantquestionlist: dependList })
    }
  }

  getTextType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.id}
        control={
          <TextField name={element.id} />
        }
      />
    );
  }

  getDateType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.id}
        control={
          <TextField type="date" name={element.id} />
        }
      />
    );
  }

  getRadioType(element) {
    if (Object.keys(this.state.adminObj).length != 0) {
      let values = element.response != undefined ? element["response"]["value"][0] : '';
      let name = element.id
      return <RadioElements type={'parent'} values={values} name={name} element={element} handleChangeRadio={this.handleChangeRadio} ></RadioElements>
    } else {
      return this.planeLabels(element)
    }
  }

  planeLabels(element) {
    console.log(element.optionMap)
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    options.map((o, i) => {
      radiobuttons.push(
        <label class="MuiFormControlLabel-root formlabel mb-20px" key={i}>
          <span class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">{element.optionMap[o]}</span>
        </label>
      );
    });

    return radiobuttons
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);
    keys.map((o, i) => {
      checkbuttons.push(
        <FormControlLabel
          key={i}
          name={element.id}
          value={o}
          control={<Checkbox name={element.id} />}
          label={element.optionMap[o]}
          onChange={this.handleChangeCheckbox}
        />
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newQuestionnaire = withStyles(useStyles)(withTranslation()(Questionnaire));
export default connect(mapStateToProps, {})(newQuestionnaire);
